import React, { useEffect, useState } from "react";
import { Loader2, Power } from "lucide-react";

// Retry pill while the server wakes; if it stays unreachable, a full page load wakes it.
export const ConnectionBanner = () => {
  const [pending, setPending] = useState(0);
  const [asleep, setAsleep] = useState(false);

  useEffect(() => {
    const onWake = (e) => {
      const n = Number(e.detail) || 0;
      if (n < 0) setAsleep(false);
      setPending((p) => Math.max(0, p + n));
    };
    const onAsleep = () => navigator.onLine && setAsleep(true);
    window.addEventListener("server-waking", onWake);
    window.addEventListener("server-asleep", onAsleep);
    return () => {
      window.removeEventListener("server-waking", onWake);
      window.removeEventListener("server-asleep", onAsleep);
    };
  }, []);

  if (typeof navigator !== "undefined" && !navigator.onLine) return null;
  if (asleep) {
    return (
      <button
        type="button"
        data-testid="wake-server-btn"
        onClick={() => window.location.reload()}
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-2 rounded-full bg-red-600 text-white text-sm font-semibold py-2.5 px-5 shadow-lg active:scale-95 transition-transform"
      >
        <Power className="w-4 h-4" /> Server is asleep — tap to wake up
      </button>
    );
  }
  if (pending <= 0) return null;
  return (
    <div
      data-testid="connection-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-2 rounded-full bg-amber-500 text-black text-xs sm:text-sm font-medium py-2 px-4 shadow-lg"
    >
      <Loader2 className="w-4 h-4 animate-spin" />
      Reconnecting to server… please wait
    </div>
  );
};
